// dbServices.js

import { db } from "./firebase";  // Import Firestore instance
import { doc, getDoc, setDoc } from "firebase/firestore";

// Save user's text and title to Firestore
export const saveUserText = async (uid, title, text) => {
    try {
        const docRef = doc(db, "userTexts", userId);
        await setDoc(docRef, {
            title: title,
            text: text
        });
        console.log("Document successfully written!");
    } catch (error) {
        console.error("Error writing document: ", error);
    }
};


// Get user's text and title from Firestore
export const getUserText = async (uid) => {
    try {
        const docRef = doc(db, "userTexts", uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            return docSnap.data();  // Return title and text
        } else {
            console.log("No such document!");
            return null;
        }
    } catch (error) {
        console.error("Error getting text:", error);
        return null;
    }
};
